import { atom } from 'jotai';

import { ToastProps } from './types';

export const toastAtom = atom<ToastProps | null>(null);
toastAtom.debugLabel = 'toastAtom';
